import axios from 'axios'

export type AgencyAppConfig = {
  apiUrl: string;
  providerFrontendUrl?: string;
  customerFrontendUrl?: string;
  websocketUrl?: string;
  sentryDsn?: string;
  stripePublishable: string;
  sourceSystem: string;
  minTemplatePrice: number;
  minCorrectionPrice: number;
  minFullTranslationPrice: number;
  authApiUrl: string;
  longDateFormat: string;
  shortDateFormat: string
}

export const configSetup = async (): Promise<AgencyAppConfig> => {
  if (process.env.NODE_ENV === 'production') {
    const result = await axios.get<AgencyAppConfig>('/config.json', { baseURL: '/' })

    if (typeof result.data !== 'object') {
      throw new Error('Invalid production config')
    }
    return result.data
  }

  const config: AgencyAppConfig = {
    apiUrl: `${process.env.VUE_APP_API_URL ?? 'http://localhost:4000'}/api/v1`,
    providerFrontendUrl: process.env.VUE_APP_PROVIDER_FRONTEND_URL || "",
    customerFrontendUrl: process.env.VUE_APP_CUSTOMER_FRONTEND_URL || "",
    websocketUrl: process.env.VUE_APP_WEBSOCKET_URL ?? 'http://localhost:4001',
    sentryDsn: process.env.VUE_APP_SENTRY_DSN,
    stripePublishable: process.env.VUE_APP_STRIPE_PUBLISHABLE || "",
      sourceSystem: process.env.VUE_APP_SOURCE_SYSTEM || "_not_set",
    minTemplatePrice: 24.95,
    minCorrectionPrice: 1,
    minFullTranslationPrice: 10,
    authApiUrl: process.env.AUTH_APP_API_URL ?? 'http://localhost:4010',
    longDateFormat: process.env.LONG_DATE_FORMAT ?? 'dd MMM yyyy',
    shortDateFormat: process.env.SHORT_DATE_FORMAT ?? 'dd/MM/yyyy'
  }

  return config
}
